/**
 *
 * @author Matthew Rawson @ 22/08/2018 17:16
 * @description
 * @notes
 */
import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"
import {Col, Row} from "react-bootstrap"
import styled from "styled-components"

import id from "@irati/utils/id"
import {USER_REMINDER_AFTER_DAYS_PROPERTY, UserReminderAfterDays} from "@irati-web/fields/schedule"
import H3 from "@irati/ui/src/Headings/H3"
import {Para} from "@irati/ui/src/Labels"
import padding from "@irati/ui/src/global/padding"
import {FormattedMessage} from "@irati/utils/lang"
import Tenant from "@irati-web/fields/schedule/preferences/placeholders/Tenant"
import {injectIntl} from "@irati/utils/lang/injectIntl"

import {Email} from "../../Schedule"
import {Hr} from "../../../ui/Layout"
import widths from "../../../ui/widths"


const Heading = styled(H3)`
  padding-bottom: ${padding.tiny};
`

const Description = styled(Para)`
  max-width: ${widths.medium};
`

class EmailSection extends PureComponent {
  static propTypes = {
    form: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    formatMessage: PropTypes.func.isRequired
  }

  static defaultProps = {
    disabled: false
  }

  render() {
    const idNamespace = id("EmailSection", this.props)
    const {form, onChange, disabled, formatMessage} = this.props
    const hasUserReminderAfterDays = get(form, USER_REMINDER_AFTER_DAYS_PROPERTY) > 0
    const {runOnce} = form
    const descriptionContentId = runOnce
      ? "insights.survey.runOnce.edit.emailSection.surveyEmail.description"
      : "insights.survey.edit.emailSection.surveyEmail.description"
    const tenantHint = runOnce ? formatMessage({id: "insights.fields.schedule.runOnce.preferences.placeholders.tenant.hint"}) : undefined
    return (
      <div id={idNamespace}>
        <Heading> <FormattedMessage id="insights.survey.edit.emailSection.surveyEmail.title" /></Heading>
        <Description> <FormattedMessage id={descriptionContentId} /> </Description>
        <Row>
          <Col>
            <Tenant disabled={disabled} id={idNamespace} schedule={form} onChange={onChange} hint={tenantHint} />
          </Col>
        </Row>

        <Email
          id={id("UserSurvey", idNamespace)}
          property="preferences.emails.userSurvey"
          disabled={disabled}
          schedule={form}
          onChange={onChange} />

        <Hr />

        <Heading> <FormattedMessage id="insights.survey.edit.emailSection.followUpEmail.title" /></Heading>
        <Description> <FormattedMessage id="insights.survey.edit.emailSection.followUpEmail.description" /> </Description>

        <Row>
          <Col xs={12}>
            <UserReminderAfterDays disabled={disabled} id={id("UserReminderAfterDays", idNamespace)} schedule={form} onChange={onChange} />
          </Col>
        </Row>
        {hasUserReminderAfterDays && (

          <Email
            id={id("UserReminder", idNamespace)}
            property="preferences.emails.userReminder"
            schedule={form}
            onChange={onChange} />

        )}
      </div>
    )
  }
}

export default injectIntl(EmailSection)
